"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = void 0;
const roarr_1 = require("roarr");
exports.Logger = roarr_1.Roarr.child({
    package: 'http-terminator',
});
